import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import * as CryptoJS from "crypto-js";
// import { Geolocation } from "@capacitor/geolocation";
// import { StorageService } from 'src/app/shared/services/storage.service';

import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class Utils {
    public Translation: any = {};

    constructor(
        // private StorageService: StorageService,
        private TranslateService: TranslateService,
    ) {
        this.TranslateService.get(['SUCCESS', 'ERRORS', 'BUTTONS']).subscribe((Translation: string) => { this.Translation = Translation; });
    }

    public showSpiner(data?: any): void {
        
    }

    public closeSpiner(time?: number | undefined): void {
        var self = this;
        (!time) ? time = 0 : false;

        setTimeout(function () {
            
        }, time);
    }

    public downloadCSV(data: any) {
        data.file_name = (data.file_name != undefined) ? data.file_name + '.csv' : 'download-file.csv'; // new Date(date * 1000)
        let file = window.URL.createObjectURL(data);
        const link = document.createElement('a');

        link.href = file;
        link.download = data.file_name;
        link.setAttribute('style', 'display: none');
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(file);
        link.remove();
    }

    public downloadFromLink(url: string, data: any) {
        data.file_name = (data.file_name != undefined) ? data.file_name + '.pdf' : 'download-file.pdf';
        const link = document.createElement('a');

        link.download = data.file_name;
        link.setAttribute('target', '_blank');
        link.setAttribute('style', 'display: none');
        link.href = url + '&' + this.getPlainParams(data);
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    getPlainParams(data: { [x: string]: string; }) {
        var params = '';
        for (var key in data) {
            if (key == 'column_data') {
                params += key + '=' + data[key];
            } else {
                params += key + '=' + data[key] + '&';
            }
        }
        return params;
    }

    getUUID(length: number = 8) {
        let text = '';
        const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return `${(new Date().getTime() / 1000).toFixed(0)}-${text}`;
    }

    getRandomID(length: number = 8, type = 'mixed') {
        let text = '';
        let possible = '';

        if (type == 'numeric') {
            possible = '0123456789';
        } else {
            possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        }


        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }

        return text;
    }

    public validateChars(char: string) {
        let return_data = false;
        const chars = 'ABCDEFGHIJKLMNÑOPQRSTUVWXYZabcdefghijklmnñopqrstuvwxyz0123456789.-_¿?@';
        return_data = chars.includes(char)
        // console.log(char);

        if (char == 'Enter') {
            return_data = true;
        }

        return return_data;
    }

    static isMobile() {
        return window && window.matchMedia('(max-width: 767px)').matches;
    }

    public sorter(data: any | undefined, field: string) {
        (data == undefined) ? data = [] : false;

        if (data[field] != undefined) {
            if (data[field] == 'DESC') {
                data[field] = 'ASC';
            } else if (data[field] == 'ASC') {
                // data.splice(field);
                let temp_data = data;
                data = [];

                for (let key in temp_data) {
                    (key != field) ? data[key] = temp_data[key] : false;
                }
            } else if (data[field] == '') {
                data[field] = 'DESC';
            }
        } else {
            data[field] = 'DESC';
        }

        return data;
    }

    public dateToUnixDate(date?: any) {
        if (date) {
            const timestamp = new Date(date.year, date.month - 1, date.day).getTime() / 1000;

            if (isNaN(timestamp)) {
                return '';
            }

            return parseInt(timestamp.toFixed(0));
        } else {
            return (new Date().getTime() / 1000).toFixed(0);
        }
    }

    public unixDateToDate(date: number) {
        const new_date = new Date(date * 1000);
        const utc_string = new_date.toUTCString();
        const time = utc_string.slice(-11, -4);
        const day = new_date.getDate();
        const month = new_date.getMonth() + 1;
        const year = new_date.getFullYear();

        return { month: month, day: day, year: year, time: time, full_date: `${day}-${month}-${year} ${time}` };
    }

    public getWeek(date?: any) {
        var today = new Date(), i = 0, f, week = (new Date(today.getFullYear(), 0, 1).getDay() > 0) ? 1 : 0;
        while ((f = new Date(today.getFullYear(), 0, ++i)) < today) {
            if (!f.getDay()) {
                week++;
            }
        }
        return week;
    }
    
    public formatPrice = (value: number) => {
        let format_value = (value / 1).toFixed(2);

        return '$' + format_value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    public formatNumber(number: number, format = '1,000.00', currency = '', currency_position = 'before') {
        let new_number = '';
        let decimals = 0;
        let separator = '';
        let decimalpoint = '';

        switch (format) {
            default:
                decimals = 0; decimalpoint = ''; separator = '';
                break;

            case '1,000.00':
                decimals = 2; decimalpoint = '.'; separator = ',';
                break;

            case '1,000.000':
                decimals = 3; decimalpoint = '.'; separator = ',';
                break;

            case '1,000':
                decimals = 0; decimalpoint = '.'; separator = ',';
                break;

            case '1.000,00':
                decimals = 2; decimalpoint = ','; separator = '.';
                break;

            case '1.000,000':
                decimals = 3; decimalpoint = ','; separator = '.';
                break;

            case '1.000':
                decimals = 0; decimalpoint = ','; separator = '.';
                break;
        }

        if (currency) {
            (decimals > 0) ? new_number = (number / 1).toFixed(decimals) : false;
            new_number = new_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
            new_number = (currency_position == 'before') ? currency + new_number : new_number + currency;
        } else {
            (decimals > 0) ? new_number = (number / 1).toFixed(decimals) : false;
            new_number = new_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
        }

        return new_number;
    }
    
    /**
    * The function sleep() takes a number of milliseconds as an argument and returns a promise that
    * resolves after the specified number of milliseconds.
    * @param {number | undefined} ms - The number of milliseconds to wait before resolving the
    * promise.
    * @returns a promise.
    */
    async sleep(ms: number | undefined) {
        return await new Promise(resolve => setTimeout(resolve, ms));
    }

    encrypt(value: any, key:any = null): string {
        return CryptoJS.AES.encrypt( value, key || environment.public_key ).toString();
    }
}
